import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Space } from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import {
  ModalItemPrice,
  ModalUnitMeasure,
} from '../../components/upeosoft/ModalApp/ModalApp';
import StatusTag from '../../hooks/StatusHook';
import { deleteItemPrice, getItemPrice } from '../../network/itemPrice';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import DashboardCards from '../Dashboard/DashboardCards';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';

const ItemPrice = ({ t }) => {
  const client = useQueryClient();
  // const [searchText, setSearchText] = useState('');
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    // console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };
  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteItemPrice(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getItemPrice] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getItemPrice, searchText.key, searchText.value],
    queryFn: () =>
      getItemPrice({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.ItemPrice,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setEditId(record?.name);
        setOpen(true);
        setEdit(true);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.DeleteUnitMeasure + ` (${record?.item_name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.ItemPrice}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.itemName,
      dataIndex: 'item_name',
      key: 'item_name',
      ...props({ key: 'item_name', name: t.itemName }),
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              setEditId(record?.name);
              setOpen(true);
              setEdit(true);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.PriceList,
      dataIndex: 'price_list',
      ...props({ key: 'price_list', name: t.PriceList }),
    },
    {
      title: t.currency,
      dataIndex: 'currency',
    },
    {
      title: t.priceListRate,
      dataIndex: 'price_list_rate',
    },
    {
      title: t.ValidFrom,
      dataIndex: 'valid_from',
    },
    {
      title: t.buying,
      dataIndex: 'buying',
      key: 'buying',
      render: (text, record) => (
        <StatusTag status={record?.buying === 1 ? 'Yes' : 'No'} />
      ),
    },
    // {
    //     title: t.status,
    //     dataIndex: 'enabled',
    //     render: (text, record) => <StatusTag status={record?.enabled === 1 ? 'Enabled' : 'Disabled'} />,
    // },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title={t.DeleteUnitMeasure + ` (${record?.item_name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.Inventory } subTitle={t.ItemPrice} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
                setEdit(false);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddItemPrice}
            </Button>
          }
        />
      </div>
      <ModalItemPrice
        open={open}
        setOpen={setOpen}
        edit={edit}
        editId={editId}
        setEditId={setEditId}
        t={t}
        setEdit={setEdit}
      />
    </div>
  );
};

export default ItemPrice;
